export namespace AppCoreEnums {
  export enum ContainerType {
    NotSpecifiedContainer = 0,
    CollapsibleTableContainer = 1,
    TableContainer = 2,
    LogsTableContainer = 3,
    TabsContainer = 5,
    CollapsibleFiltersContainer = 6,
    DrawerContainer = 7,
    FormsContainer = 8,
    EmptyContainer = 9,
    CollapsibleContainer = 10,
    CollapsibleTableInnerContainer = 11,
    TableInnerContainer = 12,
    ListContainer = 13,
    SideMenuContainer = 14
  }

  export enum ToastNotificationType {
    Success = 1,
    SuccessDelete = 2,
    Error = 3,
    Warning = 4,
    UserFeeling = 5,
    UserFeelingThanks = 6,
    Feedback = 7,
    FeedbackThanks = 8
  }

  export enum NotificationTypes {
    Info = 1,
    Error = 2,
    Success = 3,
    Warning = 4,
  }

  export enum FilterItemType {
    None = 0,
    Select = 1,
    DateWithTime = 2,
    Text = 3,
    MultiSelect = 4,
    Date = 5,
  }

  export enum DynamicFilterDateRangeOptionsEnum {
    Last2Days = 0,
    Last7Days = 1,
    Last15Days = 2,
    Today = 3,
    Yesterday = 4,
    Custom = 5,
  }

  export enum DynamicFilterOperatorsEnum {
    Equal = 0,
    InBetween = 1,
  }

  export enum MainMenuItemTypes {
    Regular = 0,
    SectionTitle = 1,
    ExpansionParentItem = 2,
    ExpansionChildItem = 3,
  }

  export enum RightSideDrawerSize {
    Small = 1,
    Medium = 2,
    Medium2 = 3,
    Large = 4,
    Extralarge = 5,
  }

  export enum ConfirmationResult {
    No = 0,
    Yes = 1,
    Cancel = 2,
  }

  export enum ToolbarItemTypes {
    Button = 'button',
    InputSwitch = 'input-switch',
    ButtonMenu = 'button-menu',
  }

  export enum UserFeelingFeedback {
    VeryNegative = 1,
    Negative = 2,
    Neutral = 3,
    Positive = 4,
    VeryPositive = 5,
  }
}
